import React, { useState } from 'react'

import '../styles/modalItem.css'

import ModalAddSuccess from './ModalAddSuccess'
import { TYPE_CONFIG } from '../admin/shared/lestnicyTypeConfig'

import LestnicySizesImage from '../images/lestnicySizes.png'
import StremyankiSizesImage from '../images/stremyankiSizes.png'
import VyshkiSizesImage from '../images/vyshkiSizes.png'
import PodmostySizesImage from '../images/podmostySizes.png'
import KrukSizesImage from '../images/krukSizes.png'
import StolSizesImage from '../images/stolSizes.png'

const PRICE_ON_REQUEST = 'уточняйте'

function ModalItem ({ item, onHide, addToCart }) {
    const [showOk, setShowOk] = useState(false)
    const lestnicyVariantConfig = TYPE_CONFIG[item?.type]
    const isLestnicyType = Boolean(lestnicyVariantConfig)
    const lestnicySizes = lestnicyVariantConfig?.sizes || []
    const lestnicyImage = lestnicyVariantConfig?.image || LestnicySizesImage
    const isPriceOnRequest = (price) => String(price ?? '').trim().toLowerCase() === PRICE_ON_REQUEST

    const addItem = (item) => {
        addToCart (item)
        setShowOk(true)
    }

    const closeModal = () => {
        const body = document.querySelector('body');
        body.style.overflowY = 'auto';
        onHide()
    }

    const body = document.querySelector('body')
    body.style.overflowY = 'hidden'

    return <div className='modal'>
        <div className='modal__item'>
            <div className='modal__cancel_button' onClick={e => closeModal()}></div>
            <div className='item_info'>
                <div className='wrap-img'><img className='info-img' src={item.image} alt='строительные материалы'/></div>
                <div className='info-item-desc'>
                    <div className='info-title'>{item.title}</div>
                    
                    {item.brand && <div className='info-brand'>Производитель: {item.brand}</div>}
                    {
                        item.price == 0 ?
                        <div className='info-price'>нет в наличии</div>
                        :
                        <>
                        <div className='info-price'>{isPriceOnRequest(item.price) ? item.price : `${item.price} BYN`}</div>
                        <button className='info-button' onClick={ e => addItem(item)}>добавить в корзину</button>
                        </>
                    }
                    
                </div>
            </div> 
            <div className='info-des'>Описание:</div>
            {item?.type === 'stremyanki' && (
                <>
                    <img src={StremyankiSizesImage} className='size-image' />
                    <div className='sizes-table-container'>
                        <table className='sizes-table'>
                            <thead>
                                <tr>
                                    <th>Артикул</th>
                                    <th>Ступени</th>
                                    <th>A, м</th>
                                    <th>B, м</th>
                                    <th>C, м</th>
                                    <th>D, м</th>
                                    <th>E, м</th>
                                    <th>Вес, кг</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>{item.article}</td>
                                    <td>{item.steps}</td>
                                    <td>{item.sizes && item.sizes[0]}</td>
                                    <td>{item.sizes && item.sizes[1]}</td>
                                    <td>{item.sizes && item.sizes[2]}</td>
                                    <td>{item.sizes && item.sizes[3]}</td>
                                    <td>{item.sizes && item.sizes[4]}</td>
                                    <td>{item.weight}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </>
            )}
            {isLestnicyType && (
                <>
                    <img src={lestnicyImage} className='size-image' alt='Схема размеров лестницы' />
                    <div className='sizes-table-container'>
                        <table className='sizes-table'>
                            <thead>
                                <tr>
                                    <th>Артикул</th>
                                    <th>Ступени</th>
                                    {lestnicySizes.map(({ label, unit }) => (
                                        <th key={`${label}-${unit}`}>{label}, {unit}</th>
                                    ))}
                                    <th>Вес, кг</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>{item.article}</td>
                                    <td>{item.steps}</td>
                                    {lestnicySizes.map((_, index) => (
                                        <td key={`size-value-${index}`}>{item.sizes && item.sizes[index]}</td>
                                    ))}
                                    <td>{item.weight}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </>
            )}
            {item?.type === 'vyshki' && (
                <>
                    <img src={VyshkiSizesImage} className='size-image' />
                    <div className='sizes-table-container'>
                        <table className='sizes-table'>
                            <thead>
                                <tr>
                                    <th>Артикул</th>
                                    <th>Ступени</th>
                                    <th>A, м</th>
                                    <th>B, м</th>
                                    <th>C, м</th>
                                    <th>D, м</th>
                                    <th>E, м</th>
                                    <th>F, м</th>
                                    <th>G, м</th>
                                    <th>H, м</th>
                                    <th>I, м</th>
                                    <th>J, м</th>
                                    <th>K, м</th>
                                    <th>L, м</th>
                                    <th>Вес, кг</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>{item.article}</td>
                                    <td>{item.steps}</td>
                                    <td>{item.sizes && item.sizes[0]}</td>
                                    <td>{item.sizes && item.sizes[1]}</td>
                                    <td>{item.sizes && item.sizes[2]}</td>
                                    <td>{item.sizes && item.sizes[3]}</td>
                                    <td>{item.sizes && item.sizes[4]}</td>
                                    <td>{item.sizes && item.sizes[5]}</td>
                                    <td>{item.sizes && item.sizes[6]}</td>
                                    <td>{item.sizes && item.sizes[7]}</td>
                                    <td>{item.sizes && item.sizes[8]}</td>
                                    <td>{item.sizes && item.sizes[9]}</td>
                                    <td>{item.sizes && item.sizes[10]}</td>
                                    <td>{item.sizes && item.sizes[11]}</td>
                                    <td>{item.weight}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </>
            )}
            {item?.type === 'podmosty' && (
                <>
                    <img src={PodmostySizesImage} className='size-image' />
                    <div className='sizes-table-container'>
                        <table className='sizes-table'>
                            <thead>
                                <tr>
                                    <th>Артикул</th>
                                    <th>Ступени</th>
                                    <th>A, м</th>
                                    <th>B, м</th>
                                    <th>C, м</th>
                                    <th>D, м</th>
                                    <th>E, м</th>
                                    <th>F, м</th>
                                    <th>G, м</th>
                                    <th>H, м</th>
                                    <th>Вес, кг</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>{item.article}</td>
                                    <td>{item.steps}</td>
                                    <td>{item.sizes && item.sizes[0]}</td>
                                    <td>{item.sizes && item.sizes[1]}</td>
                                    <td>{item.sizes && item.sizes[2]}</td>
                                    <td>{item.sizes && item.sizes[3]}</td>
                                    <td>{item.sizes && item.sizes[4]}</td>
                                    <td>{item.sizes && item.sizes[5]}</td>
                                    <td>{item.sizes && item.sizes[6]}</td>
                                    <td>{item.sizes && item.sizes[7]}</td>
                                    <td>{item.weight}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </>
            )}
            {item?.type === 'kruk' && (
                <>
                    <img src={KrukSizesImage} className='size-image' />
                    <div className='sizes-table-container'>
                        <table className='sizes-table'>
                            <thead>
                                <tr>
                                    <th>Артикул</th>
                                    <th>A, м</th>
                                    <th>B, м</th>
                                    <th>C, м</th>
                                    <th>D, м</th>
                                    <th>E, м</th>
                                    <th>F, м</th>
                                    <th>G, м</th>
                                    <th>Вес, кг</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>{item.article}</td>
                                    <td>{item.sizes && item.sizes[0]}</td>
                                    <td>{item.sizes && item.sizes[1]}</td>
                                    <td>{item.sizes && item.sizes[2]}</td>
                                    <td>{item.sizes && item.sizes[3]}</td>
                                    <td>{item.sizes && item.sizes[4]}</td>
                                    <td>{item.sizes && item.sizes[5]}</td>
                                    <td>{item.sizes && item.sizes[6]}</td>
                                    <td>{item.weight}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </>
            )}
            {item?.type === 'stol' && (
                <>
                    <img src={StolSizesImage} className='size-image' />
                    <div className='sizes-table-container'>
                        <table className='sizes-table'>
                            <thead>
                                <tr>
                                    <th>Артикул</th>
                                    <th>A, м</th>
                                    <th>B, м</th>
                                    <th>C, м</th>
                                    <th>D, м</th>
                                    <th>E, м</th>
                                    <th>F, м</th>
                                    <th>G, м</th>
                                    <th>Вес, кг</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>{item.article}</td>
                                    <td>{item.sizes && item.sizes[0]}</td>
                                    <td>{item.sizes && item.sizes[1]}</td>
                                    <td>{item.sizes && item.sizes[2]}</td>
                                    <td>{item.sizes && item.sizes[3]}</td>
                                    <td>{item.sizes && item.sizes[4]}</td>
                                    <td>{item.sizes && item.sizes[5]}</td>
                                    <td>{item.sizes && item.sizes[6]}</td>
                                    <td>{item.weight}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </>
            )}
            <div className='info-description'>{item.description}</div>  
        </div>
        {
            showOk ? 
            <ModalAddSuccess onHide={e => setShowOk(false)}/>
            : null
        }
    </div>
}

export default ModalItem

/**
 * <div className='info-item'>
                <div className='wrap-img'><img className='info-img' src={item.image} alt='строительные материалы'/></div>
                <div className='info-item-desc'>
                    <div className='info-title'>{item.title}</div>
                    <div className='info-brand'>Бренд: {item.brand}</div>
                    <div className='info-price'>{item.price}</div>
                </div>
            </div>
            <div className='info-description'>{item.description}</div>
 */